<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-text>
        <h4 class="pt-7">{{ message }}</h4>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="dialog = false"> Close </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChartNoticeDialog',

  data() {
    return {
      dialog: false,
      message: '',
    };
  },

  methods: {
    showDialog(message) {
      this.message = message;
      this.dialog = true;
    },
  },
};
</script>

<style scoped></style>
